import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import PropTypes from "prop-types";
import { useMediaQuery, useTheme } from "@mui/material";

const Timer = forwardRef(({ expiryTime, onExpire, message }, ref) => {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(expiryTime));
  const [isRunning, setIsRunning] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useImperativeHandle(ref, () => ({
    stopTimer: () => {
      setIsRunning(false);
    },
  }));

  useEffect(() => {
    if (!isRunning) return;

    const timerInterval = setInterval(() => {
      const remainingTime = calculateTimeLeft(expiryTime);
      setTimeLeft(remainingTime);

      if (remainingTime.total <= 0) {
        clearInterval(timerInterval);
        setIsRunning(false);
        if (onExpire) {
          onExpire();
        }
      }
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [expiryTime, onExpire, isRunning]);

  const formatTime = (time) => {
    const addLeadingZero = (num) => String(num).padStart(2, "0");

    return `${addLeadingZero(Math.max(0, time.hours))}:${addLeadingZero(
      Math.max(0, time.minutes)
    )}:${addLeadingZero(Math.max(0, time.seconds))}`;
  };

  return (
    <div>
      {timeLeft.total > 0 ? (
        <p
          style={{
            fontSize: isMobile ? "0.9rem" : "0.9rem",
            lineHeight: "1.2",
            fontWeight: "700",
            margin: isMobile ? "1rem auto 0 auto" : "0.5rem auto 0 auto",
            color: "#E54F9C",
            position: "absolute",
            top: isMobile ? "22rem" : "20.65rem",
            left: "50%",
            transform: "translateX(-50%)",

          }}
        >
          code will expire in:<br/>
          <span style={{ color: "#000000" }}>{formatTime(timeLeft)} </span>
        </p>
      ) : (
        <p
          style={{
            fontSize: "1.4rem",
            lineHeight: "1.4",
            fontWeight: "500",
            textTransform: "uppercase",
            marginTop: "4rem",
          }}
        >
          Time Expired!
        </p>
      )}
    </div>
  );
});

// Helper function to calculate remaining time
const calculateTimeLeft = (expiryTime) => {
  const now = new Date().getTime();
  const difference = expiryTime - now;

  return {
    total: difference,
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / (1000 * 60)) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
};

Timer.propTypes = {
  expiryTime: PropTypes.number.isRequired, // Expiry time as a timestamp
  onExpire: PropTypes.func, // Callback for when timer expires
};

export default Timer;
